(() => {
    angular
          .module('kareo.ui.shared.directives.k-constants', [])
          .constant('TRIZETTO_CLEARINGHOUSE_ID', 3)
          .constant('JOPARI_CLEARINGHOUSE_ID', 6)
          .constant('KAREO_PLATFORM_EDITIONSET', 25)
          .constant('BILLCO_PLATFORM_EDITIONSET', 26)
          .constant('SUPERVISING_PROVIDER', 11);
  })();